import QuestionsAccordion from "./QuestionsAccordion";

export default QuestionsAccordion;
